import React, { useState,useEffect }  from 'react';
import axios from 'axios'
import CategoryPs from './placeholders/categoryPs';
import settings from '../../settings.json'
import TitoloPagine from './TitoloPagine';

function Filters(props) {
    const [loading, setLoading] = useState(true)
    const [categories, setCategories] = useState([])
    const [collections, setCollections] = useState([])
    const [selectedCategory, setselectedCategory] = useState(null)
    const [selectedCollection, setselectedCollection] = useState(null)
    const [collezioniListVisible, setCollezioniListVisible] = useState(false)
    const [categoryListVisible, setCategoryListVisible] = useState(false)

    useEffect(() => {
        axios.all([axios.get(settings.url_api+"/api/categoris/"),axios.get(settings.url_api+"/api/collections/")]).then((res)=>{
            setCategories(res[0].data.results)
            setCollections(res[1].data.results)
            props.setCollections(res[1].data.results)
            setLoading(false)
        })
        .catch((error)=>{
            setLoading(null)
        })
    }, [])

    function setCategoriesAndFilter(category){
        setselectedCategory(category)
        let selectedCollectionId = null
        let selectedCategoryId = null
        if(selectedCollection){
            selectedCollectionId = selectedCollection.id
        }
        if(category){
            selectedCategoryId = category.id
        }
        props.filter(selectedCategoryId,selectedCollectionId)
    }

    function setCollectionAndFilter(collection){
        console.log(collection)
        setselectedCollection(collection)
        let selectedCategoryId = null
        let selectedCollectionId = null
        if(selectedCategory){
            selectedCategoryId = selectedCategory.id
        }
        if(collection){
            selectedCollectionId = collection.id
        }
        props.filter(selectedCategoryId,selectedCollectionId)
    }
    return (
        <>
            {loading ? <CategoryPs></CategoryPs> :
            <>
                <div className="d-block d-sm-none">
                    Inserire select per ordinare per prezzo / selezionare categoria
                </div>
                {collections.length > 0 ?
                    <div style={{textAlign:"left",marginBottom:"15px"}} className="d-none d-sm-block">
                        <div className="row intestazione-border-black" onClick={()=>setCollezioniListVisible(!collezioniListVisible)}>
                            <div className="col-10" style={{padding:0,cursor:"pointer"}}>
                                COLLEZIONI
                            </div>
                            <div className="col-2">
                                <i style={{fontSize: "15px"}} className={collezioniListVisible ? "chevron-up-active fa fa-chevron-up" : "chevron-up fa fa-chevron-up" }></i>
                            </div>
                        </div>
                        {collezioniListVisible ? 
                        <div className={"filter-visible"}>
                            <div style={{cursor:"pointer"}}>
                                <span className={selectedCollection === null ? "filter-bold filter " : "filter "} onClick={()=>setCollectionAndFilter(null)} style={{color:"black", marginLeft:"5px"}}>TUTTE</span>                     
                            </div>  
                            {collections.map((collection,i)=>{
                                return(
                                <div  key={i} style={{marginTop:"5px",cursor:"pointer"}}>
                                    <i className="fa caret-left" style={{fontSize:"13px"}}></i>
                                    <span className={selectedCollection && selectedCollection.id === collection.id ? "filter filter-bold" : "filter"} onClick={()=>setCollectionAndFilter(collection)} style={{color:"black", marginLeft:"5px"}}>{collection.title}</span>
                                </div>
                                )
                            })}
                        </div>
                        :null}
                    </div>
                :null}
                {categories.length > 0 ?
                    <div style={{textAlign:"left"}} className="d-none d-sm-block">
                        <div className="row intestazione-border-black" onClick={()=>setCategoryListVisible(!categoryListVisible)}>
                            <div className="col-10" style={{padding:0, cursor:"pointer"}}>
                                CATEGORIE
                            </div>
                            <div className="col-2">
                                <i style={{fontSize: "15px"}} className={categoryListVisible ? "chevron-up-active fa fa-chevron-up" : "chevron-up fa fa-chevron-up" }></i>
                            </div>
                        </div>            
                        {categoryListVisible ?
                        <div className={"filter-visible"}>
                            <div style={{cursor:"pointer"}}>
                                <span className={selectedCategory === null ? "filter-bold filter " : "filter "} onClick={()=>setCategoriesAndFilter(null)} style={{color:"black", marginLeft:"5px"}}>TUTTE</span>                     
                            </div> 
                            {categories.map((category,i)=>{
                                return(
                                <div key={i} style={{marginTop:"5px",cursor:"pointer"}}>
                                    <span className={selectedCategory && category.id === selectedCategory.id ? "filter-bold filter" : "filter"} onClick={()=>setCategoriesAndFilter(category)} style={{color:"black", marginLeft:"5px"}}>{category.title}</span>                     
                                </div>
                                )
                            })}
                            </div>
                        :null}
                    </div>
                :null}
            </>}
        </>
    );
}

export default Filters;